var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27 51L2 26L27 1","stroke":"white","strokeWidth":"2"}));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 28 52","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
